import { Bike16, Car16, Parking16, Walk16 } from '@cian/ui-kit';
import React from 'react';

import { IconCompetitor16 } from 'shared/components/Icons/IconCompetitor16';
import { IconNoCar16 } from 'shared/components/Icons/IconNoCar16';
import { IconPolice16 } from 'shared/components/Icons/IconPolice16';
import { IconScooter16 } from 'shared/components/Icons/IconScooter16';
import { IMapRowsProps } from 'shared/components/MapRows';
import { getAvailableInsideInfrastructureTypes } from 'shared/containers/NewbuildingMapContainer/utils/transportAccessibility';
import { EInsideTAInfrastructureType, ITAInfrastructure } from 'shared/types/map';

const INFRASTRUCTURE_TYPE_TO_ROW_MAP: Record<
  EInsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EInsideTAInfrastructureType.yardWithoutCars]: {
    text: 'Двор без машин',
    IconComponent: IconNoCar16,
  },
  [EInsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: Parking16,
  },
  [EInsideTAInfrastructureType.placeOfShortTransportStop]: {
    text: 'Места для короткой остановки транспорта',
    IconComponent: Car16,
  },
  [EInsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: Bike16,
  },
  [EInsideTAInfrastructureType.chargingStations]: {
    text: 'Станции зарядки электромобилей',
    IconComponent: IconCompetitor16,
  },
  [EInsideTAInfrastructureType.scooterParking]: {
    text: 'Парковки для самокатов',
    IconComponent: IconScooter16,
  },
  [EInsideTAInfrastructureType.boulevards]: {
    text: 'Пешеходные бульвары',
    IconComponent: Walk16,
  },
  [EInsideTAInfrastructureType.trafficSafetyElements]: {
    text: 'Элементы безопасности движения',
    IconComponent: IconPolice16,
  },
};

export const getInsideRows = (transportAccessibilityInfrastructure: ITAInfrastructure | undefined) => {
  const { existingInfrastructureTypes, missingInfrastructureTypes } = getAvailableInsideInfrastructureTypes(
    transportAccessibilityInfrastructure,
  );

  const clickableRows: IMapRowsProps['items'] = existingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  const nonClickableRows: IMapRowsProps['items'] = missingInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPE_TO_ROW_MAP[type],
  }));

  return {
    clickableRows,
    nonClickableRows,
  };
};
